import React, { Component } from 'react';
import { Icon, List } from "semantic-ui-react";

/** Render a list of fees sorted by percentage in descending order */
class Fees extends Component {  
    constructor(props) {
        super(props);
        
        this.state = {
            // Keep track of the fees that are enabled / disabled
            feeEnabled: {}
        }
    }

    onFeeSelected = (e, ctl) => {
        // Toggle the selected fee.
        this.setState(prevState => {
            prevState.feeEnabled[ctl.name] = !prevState.feeEnabled[ctl.name];
            return prevState;
        })
        // Notify parent that the fee has been toggled.
        this.props.onFeeToggled && this.props.onFeeToggled(ctl.name);
    };

    componentDidUpdate(prevProps) {
        // When the fees have been provided, enable them all.
        if (prevProps.fees.length !== this.props.fees.length) {
            this.setState(prevState => {
                this.props.fees.forEach((fee) => prevState.feeEnabled[fee.id] = true);
                return prevState;
            })
        }
    }

    render() {
        if (this.props.fees === undefined) {
            return null;
        }
        return (               
            <List selection relaxed>
            {this.props.fees.sort((a, b) => b.percent - a.percent).map((fee) =>
                <List.Item name={fee.id} key={fee.id} onClick={this.onFeeSelected} > 
                    <List.Content floated='right'>                   
                    <List.Icon 
                        name={this.state.feeEnabled[fee.id]? 'toggle on' : 'toggle off'}
                        color={this.state.feeEnabled[fee.id]? 'green' : 'red'}
                        size='large'
                        verticalAlign='middle' />
                    </List.Content>
                    <List.Content >              
                        <List.Header>{fee.name}</List.Header>
                        <List.Description className={this.state.feeEnabled[fee.id]? '' : 'blur-text'}>
                            <Icon name='percent' color='blue' size='small'/>{fee.percent}%
                            <br />
                            <Icon name='plus circle' color='blue' size='small' />{fee.cost}
                        </List.Description>
                    </List.Content>                        
                </List.Item>
                
                )}                
            </List>
        );
    }
}

export default Fees;